// DOM ids and other shell values shared across app_shell, components, and hooks
// to avoid feature-import cycles.

/** Page scroll container in the product-refresh shell (`#shell-content` child). */
export const SHELL_CONTENT_SCROLL_ELEMENT_ID = 'shell-content-scroll'

/** Set on `document.documentElement` while the center column is collapsed under an expanded side panel. */
export const SHELL_CENTER_PANEL_COLLAPSED_ATTR = 'data-shell-center-panel-collapsed'

/** Window event when the settings modal rail offset is recalculated (side panel width/open). */
export const SETTINGS_MODAL_RAIL_LAYOUT_CHANGE_EVENT = 'settings-modal-rail-layout-change'
